"use client"

import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"
import { cva } from 'class-variance-authority';
const sliderVariants = cva('', {
  variants: {
    color: {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      destructive: 'bg-destructive',
      sky: 'bg-sky-500',
      violet: 'bg-violet-500',
      emerald: 'bg-emerald-500',
      rose: 'bg-rose-500',
    },
  },
  defaultVariants: {
    color: 'primary',
  },
});

const Slider = React.forwardRef(({ className, orientation = 'horizontal', color, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    orientation={orientation}
    className={cn(
      'relative flex w-full touch-none select-none items-center data-[disabled]:opacity-50',
      orientation === 'vertical' && 'h-full min-h-44 w-auto flex-col',
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        'bg-sky-100 relative grow overflow-hidden rounded-full',
        orientation === 'horizontal' ? 'h-1.5 w-full' : 'h-full w-1.5'
      )}
    >
      <SliderPrimitive.Range
        className={cn(
          'absolute',
          orientation === 'horizontal' ? 'h-full' : 'w-full',
          sliderVariants({ color })
        )}
      />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="border-primary bg-background ring-offset-background block h-4 w-4 rounded-full border shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none" />
  </SliderPrimitive.Root>
));

Slider.displayName = 'Slider';



export { Slider }
